/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketsinvoiceopen2Inputs */

const en_ticketsinvoiceopen2 = /** @type {(inputs: Ticketsinvoiceopen2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open invoice`)
};

const de_ticketsinvoiceopen2 = /** @type {(inputs: Ticketsinvoiceopen2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechnung öffnen`)
};

/**
* | output |
* | --- |
* | "Open invoice" |
*
* @param {Ticketsinvoiceopen2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketsinvoiceopen2 = /** @type {((inputs?: Ticketsinvoiceopen2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketsinvoiceopen2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketsinvoiceopen2(inputs)
	return de_ticketsinvoiceopen2(inputs)
});
export { ticketsinvoiceopen2 as "ticketsInvoiceOpen" }